const TeamSection = () => {
  return null;
};

export default TeamSection;